import { Box } from '@mui/material';
import { differenceInDays } from 'date-fns';

import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';
import { TenantUsageBucket } from '@/types/schema';

/**
 * Gets the trial message to display with remaining days if applicable
 */
function getTrialMessage(trialEndDate?: Date | null): string {
  if (!trialEndDate) {
    return 'Trial';
  }

  const daysRemaining = differenceInDays(trialEndDate, new Date());

  if (daysRemaining > 0) {
    return `${daysRemaining} days left in your trial`;
  }

  return 'Trial ended';
}

export function TrialBanner() {
  const { usageBucket, trialEndDate } = useTenantDetailsContext();

  if (usageBucket !== TenantUsageBucket.UnpaidTrial) {
    return null;
  }

  const message = getTrialMessage(trialEndDate);

  return (
    <Box
      sx={{
        textAlign: 'center',
        mr: 1.5,
      }}
    >
      <Badge variant={BadgeVariants.Accent} display={message} />
    </Box>
  );
}
